'use client';

import { useMemo } from 'react';
import { VideoTag } from '@/shared/src';
import { useSearch } from '@/app/search-context';
import { filterVideos } from './actions/list';
import Dropdown from './dropdown';

export default function SelectVideoTagsClient({
  placeholder,
  className,
  tags,
}: {
  placeholder: string,
  className: string,
  tags: VideoTag[]
}) {
  const { allVideos, selectedVideoTags, toggleVideoTag, dataLoading, pageQuery, videoSort, } = useSearch();

  const availableTagNames = useMemo(() => {
    if (!allVideos) return null;
    const filtered = filterVideos(allVideos, pageQuery, videoSort, selectedVideoTags);
    const names = new Set<string>();
    for (const v of filtered) {
      if (v.tags) for (const t of v.tags) names.add(t.name);
    }
    return names;
  }, [allVideos, pageQuery, videoSort, selectedVideoTags,]);

  const tagsToShow = tags.filter(t =>
    !selectedVideoTags.includes(t.attributes.name) &&
    (!availableTagNames || availableTagNames.has(t.attributes.name))
  );

  if (tagsToShow.length > 0) {
    return (
      <Dropdown
        className={className}
        options={tagsToShow.map(t => ({ value: t.attributes.name, label: t.attributes.name, }))}
        placeholder={placeholder}
        disabled={dataLoading}
        onChange={toggleVideoTag}
        pickMode
      />
    );
  }

  return <></>;
}
